/*
 * @Author: Teemo Ding
 * @Date: 2021-07-15 17:57:02
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-15 17:58:21
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Payment/PaymentEditPage/PaymentGateway/AtomeItem.tsx
 */
import React, { Fragment } from 'react';

import { Input, Label } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import { Form } from 'antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

export default () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <Fragment>
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='userName'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.username',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.username'),
                    ),
                  },
                ]}>
                <Input size='large' maxLength={100} />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='password'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.password',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.password'),
                    ),
                  },
                ]}>
                <Input size='large' maxLength={100} />
              </Form.Item>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='paymentURI'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.paymentURI',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.paymentURI'),
                    ),
                  },
                ]}>
                <Input size='large' maxLength={100} />
              </Form.Item>
            ),
          },
          {
            child: '',
          },
        ]}
      />
    </Fragment>
  );
};
